// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {ExternalLink} from '@app/features/app/components/shared/ExternalLink';
import {SUPPORT_EMAIL, SUPPORT_EMAIL_MAILTO} from '@app/features/app/config/I18nDisplayConstants';
import {MULTIPART_ATTACHMENT_FALLBACK_MAX_REQUEST_SIZE} from '@app/features/messaging/utils/AttachmentUploadFallbackUtils';
import {formatFileSize} from '@app/features/messaging/utils/FileUtils';
import {Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const AttachmentUploadConnectivityModal = observer(() => {
	const {t} = useLingui();
	const fallbackSizeFormatted = formatFileSize(MULTIPART_ATTACHMENT_FALLBACK_MAX_REQUEST_SIZE);
	return (
		<ConfirmModal
			title={t`Attachment upload unavailable`}
			description={
				<Trans>
					We couldn't reach the attachment upload service. Fluxer can fall back to the standard upload path for messages
					up to {fallbackSizeFormatted} total, but these attachments exceed that combined limit and can't be sent until
					connectivity is restored. Please try again later or contact{' '}
					<ExternalLink href={SUPPORT_EMAIL_MAILTO}>{SUPPORT_EMAIL}</ExternalLink> if this keeps happening.
				</Trans>
			}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
